import { defineMessages } from 'react-intl';

export const scope = 'dataset_list';

export default defineMessages({
    delete_check: {
        id: `${scope}.delete_check`,
        defaultMessage: 'Are you sure you want to delete this dataset?',
    },
    delete_success: {
        id: `${scope}.delete_success`,
        defaultMessage: 'Dataset deleted successfully.',
    },
    delete_error: {
        id: `${scope}.delete_error`,
        defaultMessage: 'Error deleting dataset. Please try again.',
    },
    invalid_dataset: {
        id: `${scope}.invalid_dataset`,
        defaultMessage: 'Invalid dataset.',
    },
    subscribe_error: {
        id: `${scope}.subscribe_error`,
        defaultMessage: 'Failed to subscribe. Please try again.',
    },
    subscribe_success: {
        id: `${scope}.subscribe_success`,
        defaultMessage: 'Subscription added successfully.',
    }
});
